import React, { useState } from 'react'
import swap from '../../assets/images/swap-vert.svg'

import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'

function BilansSwaper(props) {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen(o => !o)
  }

  const handleAktywaClick = () => {
    props.onAktywaClick()
    setOpen(false)
  }

  const handlePasywaClick = () => {
    props.onPasywaClick()
    setOpen(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <div>
        <img
          className="swap"
          src={swap}
          alt="swap"
          aria-owns={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        />
        <Popper open={open} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList>
                    <MenuItem onClick={handleAktywaClick}>
                      Przejdź do AKTYWÓW
                    </MenuItem>
                    <MenuItem onClick={handlePasywaClick}>
                      Przejdź do PASYWÓW
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  )
}

export default BilansSwaper
